import { render } from "./ResourcesSettings.vue?vue&type=template&id=690bdd72"
import script from "./ResourcesSettings.vue?vue&type=script&lang=js"
export * from "./ResourcesSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/settings/organization_profile/ResourcesSettings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "690bdd72"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('690bdd72', __exports__)) {
    api.reload('690bdd72', __exports__)
  }
  
  module.hot.accept("./ResourcesSettings.vue?vue&type=template&id=690bdd72", () => {
    api.rerender('690bdd72', render)
  })

}


export default __exports__